<template lang="pug">
    div.container-fluid.block-typical
        h2 Radio
        div.row.ui-block
            div.col-3
                h5 Basic
                el-radio(v-model='radio', label='1') Option A
                el-radio(v-model='radio', label='2') Option B
            div.col-3
                h5 Disabled
                el-radio(disabled='', v-model='radio1', label='disabled') Option A
                el-radio(disabled='', v-model='radio1', label='selected and disabled') Option B
            div.col-3
                h5 Radio button group
                el-radio-group(v-model='radio2')
                    el-radio(:label='3') Option A
                    el-radio(:label='6') Option B
                    el-radio(:label='9') Option C
        div.row.ui-block
            div.col-6
                h5 Radio Button style
                div
                    el-radio-group(v-model='radio3')
                        el-radio-button(label='New York')
                        el-radio-button(label='Washington')
                        el-radio-button(label='Los Angeles')
                        el-radio-button(label='Chicago')
                    div(style='margin-top: 20px')
                        el-radio-group(v-model='radio4', size='medium')
                            el-radio-button(label='New York')
                            el-radio-button(label='Washington')
                            el-radio-button(label='Los Angeles')
                            el-radio-button(label='Chicago')
                    div(style='margin-top: 20px')
                        el-radio-group(v-model='radio5', size='small')
                            el-radio-button(label='New York')
                            el-radio-button(label='Washington', disabled='')
                            el-radio-button(label='Los Angeles')
                            el-radio-button(label='Chicago')
                    div(style='margin-top: 20px')
                        el-radio-group(v-model='radio6', disabled='', size='mini')
                            el-radio-button(label='New York')
                            el-radio-button(label='Washington')
                            el-radio-button(label='Los Angeles')
                            el-radio-button(label='Chicago')
            div.col-6
                h5 Radio Button With borders
                div
                    el-radio(v-model='radio7', label='1', border='') Option A
                    el-radio(v-model='radio7', label='2', border='') Option B
                    div(style='margin-top: 20px')
                        el-radio(v-model='radio8', label='1', border='', size='medium') Option A
                        el-radio(v-model='radio8', label='2', border='', size='medium') Option B
                    div(style='margin-top: 20px')
                        el-radio-group(v-model='radio9', size='small')
                            el-radio(label='1', border='') Option A
                            el-radio(label='2', border='', disabled='') Option B
                    div(style='margin-top: 20px')
                        el-radio-group(v-model='radio10', size='mini', disabled='')
                            el-radio(label='1', border='') Option A
                            el-radio(label='2', border='') Option B


</template>
<script>
    export default {
        data () {
            return {
                radio: '1',
                radio2: 3,
                radio3: 'New York',
                radio4: 'New York',
                radio5: 'New York',
                radio6: 'New York',
                radio7: '1',
                radio8: '1',
                radio9: '1',
                radio10: '1'
            };
        }
    }
</script>